import React, { useState } from "react";
import { Phone } from "lucide-react";
import ContactModal from "./ContactModal";

const LpNavigation = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <nav className="bg-white/95 backdrop-blur-xl border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-3 md:px-8 lg:px-12">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <a
              href="/lp"
              className="flex items-center shrink-0"
              data-testid="lp-nav-logo"
            >
              <img
                src="/assets/img/brand/logo-dark.png"
                alt="Trademark Facility"
                className="h-8 sm:h-10 md:h-12 w-auto object-contain"
              />
            </a>

            <div className="flex items-center gap-1.5 sm:gap-4 md:gap-6">
              <a
                href="tel:+18774050574"
                className="hidden md:flex items-center gap-2 text-gray-600 hover:text-[#2d3132] transition-colors duration-200"
              >
                <Phone className="h-4 w-4" />
                <span className="font-medium text-sm">+1 (877) 405-0574</span>
              </a>

              <button
                onClick={() => setIsModalOpen(true)}
                className="px-2.5 sm:px-6 py-1.5 sm:py-2.5 text-[10px] sm:text-sm font-bold text-white rounded-lg sm:rounded-xl bg-lime hover:bg-lime-light transition-all duration-300 active:scale-95"
                data-testid="lp-register-btn"
              >
                Register Now
              </button>
              <button
                onClick={() => {
                  if (window.LiveChatWidget)
                    window.LiveChatWidget.call("maximize");
                }}
                className="px-2.5 sm:px-6 py-1.5 sm:py-2.5 text-[10px] sm:text-sm font-bold text-[#2d3132] rounded-lg sm:rounded-xl border border-gray-300 hover:border-[#2d3132] transition-all duration-300"
                data-testid="lp-chat-btn"
              >
                Chat Now
              </button>
            </div>
          </div>
        </div>
      </nav>

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Start Your Registration"
      />
    </>
  );
};

export default LpNavigation;
